import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take, tap } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';

export function getFeatureEnabledGuard(
  featureToggle: string,
  fallbackRoute: string[] = ['/']
): CanActivateFn & CanActivateChildFn {
  return () => {
    const store = inject(Store);
    const router = inject(Router);
    return store.select(getFeatureToggle(featureToggle)).pipe(
      tap(isEnabled => {
        if (!isEnabled) {
          router.navigate(fallbackRoute);
        }
      }),
      take(1)
    );
  };
}
